import { createAction, props } from '@ngrx/store';
import { HomeFeedSection } from './home-feed.model';

export const registerHomeFeedCard = createAction(
  '[Home Feed] Register Card',
  props<{ key: string; component: string; data?: any; order: number; section: HomeFeedSection }>()
);

export const removeHomeFeedCard = createAction(
  '[Home Feed] Remove Card',
  props<{ key: string; section: HomeFeedSection }>()
);
